module.exports = __webpack_public_path__ + "static/img/title_mission.36aa0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/title_mission.png
// module id = 7fOJ
// module chunks = 0